import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';

import Typography from '@material-ui/core/Typography';

const styles = {
  description: {
      height: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
  },
  cardAction: {
      display: 'block',
      width: 345,
  },
  card: {
    width: 345,
  },
  media: {
    backgroundSize: 'contain',
    objectFit: 'contain',
    height: 0,
    paddingTop: '56.25%', // 16:9

//    width: null,
//    height: 350,
//    paddingTop: 15,
    backgroundColor: 'black'
  },
};

function DatasetCard(props) {
  const { classes, dataset } = props;
  return (
    <div>
      <Card className={classes.card}>
        <ButtonBase
            className={classes.cardAction}
            onClick={event => props.history.push(`/dataset/${dataset.pk}`)}
        >
          {/*<CardHeader
                avatar={
                    <Avatar aria-label="Dataset" className={classes.avatar}>
                        YT
                    </Avatar>
                }
                title={dataset.fields.title}
            />*/}
            <CardMedia
              image={dataset.fields.thumbnail_path}
              className={classes.media}
              title={dataset.fields.name}
            />
            <CardContent>
              <Typography gutterBottom variant="headline" component="h2">{dataset.fields.name}</Typography>
              <Typography className={classes.description} component="p">{dataset.fields.description}</Typography>
            </CardContent>
        </ButtonBase>
                  {/*<CardActions>
          <Button size="small" color="primary">
            Renditions
          </Button>
          <Button size="small" color="primary" disabled="disabled">
            Entities
          </Button>
        </CardActions>*/}
      </Card>
    </div>
  );
}

DatasetCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(DatasetCard));



// WEBPACK FOOTER //
// ./src/components/dataset_card.jsx